/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileTypeEnumSchema } from "./fileTypeEnumSchema.ts";
import { z } from "zod";

export const generatePresignedUrlModelSchema = z.object({
    "fileType": z.lazy(() => fileTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Picture</b>: Картинка</li>\n<li><b>2 - Track</b>: Аудио-файл</li>\n<li><b>3 - Document</b>: Документ</li>\n</ul>\n"),
"fileName": z.string().max(100).describe("Имя файла"),
"duration": z.number().int().describe("Длительность трека (для типа файла - трек)").nullable().nullish(),
"aspectRatio": z.number().describe("Соотношение сторон (для типа файла - картинка)").nullable().nullish(),
"dominantColor": z.string().max(10).describe("Доминантный цвет (для типа файла - картинка)").nullable().nullish()
    })